import Client from '../axios-client';

const resource = '/invitation/invitations';

export default {
  getInvitationsForGrid(parameters) {
    return Client.get(`${resource}` + parameters);
  },
  getInvitation(id) {
    return Client.get(`${resource}/${id}`);
  },
  createInvitation(payload) {
    return Client.post(`${resource}`, payload);
  },
  cancelInvitation(id, version) {
    return Client.put(`${resource}/${id}/cancel?version=${version}`);
  },
  resendInvitation(id, version) {
    return Client.put(`${resource}/${id}/resend?version=${version}`);
  },
};
